document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("plan-modal");
  const openBtn = document.getElementById("open-plan-modal");
  const overlay = document.getElementById("close-plan-modal");
  const closeX = document.getElementById("x-close-plan-modal");

  const planGrid = document.querySelector(".plan-grid");
  const prevBtn = document.querySelector(".plan-nav--prev");
  const nextBtn = document.querySelector(".plan-nav--next");

  if (!modal) return;

  const open = () => {
    modal.hidden = false;
    document.documentElement.classList.add("plan-open"); // ✅ locks page scroll via CSS
  };

  const close = () => {
    modal.hidden = true;
    document.documentElement.classList.remove("plan-open");
  };

  // Open/Close modal
  openBtn?.addEventListener("click", (e) => {
    e.preventDefault();
    open();
  });
  overlay?.addEventListener("click", close);
  closeX?.addEventListener("click", close);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });

  // ✅ Make mouse wheel scroll the carousel horizontally (and NOT the page)
  planGrid?.addEventListener(
    "wheel",
    (e) => {
      // only hijack if carousel can actually scroll
      if (planGrid.scrollWidth <= planGrid.clientWidth) return;
      e.preventDefault();
      planGrid.scrollLeft += e.deltaY;
    },
    { passive: false }
  );

  // Optional arrows (if you added ‹ › buttons)
  const scrollByCard = (dir) => {
    if (!planGrid) return;
    const card = planGrid.querySelector(".plan-card");
    const amount = card ? card.getBoundingClientRect().width + 14 : 320;
    planGrid.scrollBy({ left: dir * amount, behavior: "smooth" });
  };
  prevBtn?.addEventListener("click", () => scrollByCard(-1));
  nextBtn?.addEventListener("click", () => scrollByCard(1));

  // ✅ Add selected plan to cart
  document.querySelectorAll(".add-plan").forEach((btn) => {
    btn.addEventListener("click", async () => {
      const variantId = btn.dataset.variantId;

      const deviceTitle =
        document.querySelector(".product__title h1")?.textContent?.trim() ||
        document.querySelector("h1")?.textContent?.trim() ||
        "Device";

      if (!variantId) {
        alert("Missing plan variant ID. Check data-variant-id in Liquid.");
        return;
      }

      btn.disabled = true;

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(variantId, 10),
                quantity: 1,
                properties: { "For Device": deviceTitle }
              }
            ]
          })
        });

        const data = await res.json().catch(() => ({}));

        if (!res.ok) {
          console.error("Add plan failed:", data);
          alert(`Plan add failed: ${data.description || data.message || "Unknown error"}`);
          return;
        }

        // ✅ success
        close();
        window.location.href = "/cart";
      } catch (err) {
        console.error(err);
        alert("Couldn’t add the plan due to a script/network error.");
      } finally {
        btn.disabled = false;
      }
    });
  });
});
